'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Label } from '../label/label.js';

/**
 * FieldsetLegend component, used to display a legend for a fieldset.
 *
 * @example
 * <FieldsetLegend>Skriv inn dine svar</FieldsetLegend>
 */
const FieldsetLegend = forwardRef(function FieldsetLegend(rest, ref) {
    return (jsx(Label, { asChild: true, children: jsx("legend", { ref: ref, ...rest }) }));
});

export { FieldsetLegend };
